module.exports = require("./fr-GA");